import { t } from '@hefe/i18n';
import { RequestBasePostUserInvitationLink } from '@hefe/models';
import { BasketballTeamsSlice, ModalsSlice, UsersSlice } from '@hefe/store';
import { Space } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';
import { DatePickerType } from 'antd/es/date-picker';
import { DatePickerProps } from 'antd/lib';

export default function AddInvitationLinkForm() {
  const dispatch = useAppDispatch();

  const teamsSelect = useSelector(
    BasketballTeamsSlice.basketballTeamsSelectSelector
  );

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = () => {
    dispatch(
      BasketballTeamsSlice.fetchBasketballTeamsSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    )
      .unwrap()
      .catch(() => null);
  };

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: RequestBasePostUserInvitationLink = {
      team_id: values.team_id,
      valid_until: values.valid_until,
    };

    dispatch(setLoading(true));
    dispatch(UsersSlice.generateInvitationLink(submitValues))
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <CustomForm
        key={`add-invitation-link-form`}
        formId={`add-invitation-link-form`}
        fields={[
          {
            name: 'valid_until',
            label: t('users.invitation_links.valid_until'),
            type: 'datetime',
            placeholder: t('select_date'),
            additionalProps: {
              disabledDate: (current: any) => {
                return current && current < dayjs().endOf('day');
              },
            } as DatePickerProps,
            initalValue: dayjs().add(2, 'days'),
            rules: [],
          },
          {
            name: 'team_id',
            label: t('team'),
            type: 'select',
            multiSelect: false,
            placeholder: t('select'),
            selectOptions: teamsSelect,
            rules: [],
            extraLabel: t('users.invitation_links.form.team_info'),
          },
        ]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
